import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  return {
    'Authorization': authToken ? `Bearer ${authToken}` : ''
  };
};

const ReglementFournisseurController = {
  // Paginated list of payments, optionally filtered by supplier / date range
  fetchReglements: async (pageNumber = 1, pageSize = 10, { fournisseurId = null, dateDebut = null, dateFin = null } = {}) => {
    const params = new URLSearchParams({ Size: pageSize, PageNumber: pageNumber });
    if (fournisseurId) params.set('FournisseurId', fournisseurId);
    if (dateDebut) params.set('DateDebut', dateDebut);
    if (dateFin) params.set('DateFin', dateFin);
    const res = await axios.get(`${API_URL}/ReglementFournisseur/Pagination?${params}`, { headers: getAuthHeaders() });
    return res.data;
  },

  // Balance for a single supplier: { totalAchats, totalReglements, solde, ... }
  getSolde: async (fournisseurId) => {
    const res = await axios.get(`${API_URL}/ReglementFournisseur/Solde/${fournisseurId}`, { headers: getAuthHeaders() });
    return res.data;
  },

  // Balances for all suppliers
  getAllSoldes: async () => {
    const res = await axios.get(`${API_URL}/ReglementFournisseur/Soldes`, { headers: getAuthHeaders() });
    return res.data;
  },

  // Supplier consumption: sold value (delivered+paid, no exchange) at purchase price vs advances paid
  getConsommation: async () => {
    const res = await axios.get(`${API_URL}/ReglementFournisseur/Consommation`, { headers: getAuthHeaders() });
    return res.data;
  },

  // Payment forecast calendar for a supplier for a given month
  getForecast: async (fournisseurId, annee, mois) => {
    const params = new URLSearchParams();
    if (annee) params.set('Annee', annee);
    if (mois) params.set('Mois', mois);
    const qs = params.toString();
    const res = await axios.get(`${API_URL}/ReglementFournisseur/Forecast/${fournisseurId}${qs ? `?${qs}` : ''}`, { headers: getAuthHeaders() });
    return res.data;
  },

  // Create a payment
  createReglement: async (payload) => {
    const res = await axios.post(`${API_URL}/ReglementFournisseur`, payload, { headers: getAuthHeaders() });
    return res.data;
  },

  deleteReglement: async (id) => {
    const res = await axios.delete(`${API_URL}/ReglementFournisseur/${id}`, { headers: getAuthHeaders() });
    return res.data;
  },
};

export default ReglementFournisseurController;
